import { JSON_SDK_MAJIK_ENVELOPE } from "./_packages/sdk-majik-envelope";
import { JSON_SDK_MAJIK_KEY } from "./_packages/sdk-majik-key";
// import { JSON_SDK_MAJIK_MESSAGE } from "./_packages/sdk-majik-message";
import { JSON_SDK_MAJIK_SIGNATURE } from "./_packages/sdk-majik-signature";
import { JSON_SDK_MAJIK_UNIVERSAL_ID } from "./_packages/sdk-majik-universal-id";
import { SDKPageData } from "./_types";

export const allMajikahSDK: SDKPageData[] = [
  JSON_SDK_MAJIK_KEY,
  JSON_SDK_MAJIK_SIGNATURE,
  JSON_SDK_MAJIK_UNIVERSAL_ID,
  // JSON_SDK_MAJIK_MESSAGE,
  JSON_SDK_MAJIK_ENVELOPE,
];

// Function to get content by ID
export function getSDKByID(id: string) {
  return allMajikahSDK.find((content) => content.id === id);
}

// Function to get content by Category
export function getSDKsByCategory(category: string): SDKPageData[] {
  if (!category || !Array.isArray(allMajikahSDK)) {
    return [];
  }

  const fetchedSDKs = allMajikahSDK.filter(
    (content) => content.metadata.category === category,
  );

  if (fetchedSDKs.length > 1) {
    const sortedSDKs = fetchedSDKs.sort(
      (a: SDKPageData, b: SDKPageData) =>
        new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
    );

    return sortedSDKs;
  } else {
    return fetchedSDKs;
  }
}

export function getSDKsBySubCategory(category: string): SDKPageData[] {
  if (!category || !Array.isArray(allMajikahSDK)) {
    return [];
  }

  return allMajikahSDK.filter(
    (content) => content.metadata.subcategory === category,
  );
}

export function getSDKsByAllCategories(category: string): SDKPageData[] {
  if (!category || !Array.isArray(allMajikahSDK)) {
    return [];
  }

  let byCategory = getSDKsByCategory(category);
  let bySubCategory = getSDKsBySubCategory(category);

  if (byCategory.length > 1) {
    byCategory = byCategory.sort(
      (a: SDKPageData, b: SDKPageData) =>
        new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
    );
  }

  if (bySubCategory.length > 1) {
    bySubCategory = bySubCategory.sort(
      (a: SDKPageData, b: SDKPageData) =>
        new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
    );
  }
  // Optionally deduplicate items by ID if they exist in both
  const categoryIds = new Set(byCategory.map((tool) => tool.id));
  const uniqueSubCategory = bySubCategory.filter(
    (tool) => !categoryIds.has(tool.id),
  );

  const fetchedSDKs = [...byCategory, ...uniqueSubCategory];

  return fetchedSDKs;
}

export function getRelatedSDKsByAllCategories(
  category: string,
  currentSDKID: string | null = null,
): SDKPageData[] {
  if (!category || !Array.isArray(allMajikahSDK)) {
    return [];
  }

  const byCategory = getSDKsByCategory(category);
  const bySubCategory = getSDKsBySubCategory(category);

  // Optionally deduplicate items by ID if they exist in both
  const categoryIds = new Set(byCategory.map((tool) => tool.id));
  const uniqueSubCategory = bySubCategory.filter(
    (tool) => !categoryIds.has(tool.id),
  );

  let combined = [...byCategory, ...uniqueSubCategory];

  // If currentSDKID is set, remove that tool from the results
  if (currentSDKID) {
    combined = combined.filter((tool) => tool.id !== currentSDKID);
  }

  return combined;
}

// Function to get content by Name
export function getSDKByName(name: string) {
  return allMajikahSDK.find((content) => content.metadata.sdkName === name);
}

type SDKSort = "timestamp" | "name";
type SDKOrder = "normal" | "reverse";

export function getAllSDKs(
  sort: SDKSort = "name",
  order: SDKOrder = "normal",
): SDKPageData[] {
  if (!Array.isArray(allMajikahSDK)) {
    return [];
  }

  const SDKs = [...allMajikahSDK];

  SDKs.sort((a, b) => {
    if (sort === "timestamp") {
      return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
    }

    // Default: sort by SDK name alphabetically
    return a.metadata.sdkName.localeCompare(b.metadata.sdkName, undefined, {
      sensitivity: "base",
    });
  });

  if (order === "reverse") {
    SDKs.reverse();
  }

  return SDKs;
}
